import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import projectReducer from './slices/projectSlice';
import profileReducer from './slices/profileSlice';
import permissionReducer from './slices/permissionSlice';
import userReducer from './slices/userSlice';
import employeeReducer from './slices/employeeSlice';
import customerReducer from './slices/customerSlice';
import userProjectsReducer from './slices/userProjectsSlice';
import teamMembersReducer from './slices/teamMembersSlice';
import invoiceReducer from './slices/invoiceSlice';
import taskSheetReducer from './slices/taskSheetSlice';
import attendanceReducer from './slices/attendanceSlice';

// Log the reducers we're registering
console.log('Configuring Redux store with reducers:', {
  auth: 'authReducer',
  projects: 'projectReducer',
  profile: 'profileReducer',
  permissions: 'permissionReducer',
  users: 'userReducer',
  employees: 'employeeReducer',
  customers: 'customerReducer',
  userProjects: 'userProjectsReducer',
  teamMembers: 'teamMembersReducer',
  invoice: 'invoiceReducer',
});

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectReducer,
    profile: profileReducer,
    permissions: permissionReducer,
    users: userReducer,
    employees: employeeReducer,
    customers: customerReducer,
    userProjects: userProjectsReducer,
    teamMembers: teamMembersReducer,
    invoice: invoiceReducer,
    taskSheet: taskSheetReducer,
    attendance: attendanceReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Log initial state
console.log('Initial Redux state:', store.getState());

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
